module.exports = __webpack_public_path__ + "media/contact/map2-e05fad25.jpg";